import { call, options, params } from './helpers';

export const getAllSources = (payload) =>
	call(`/beta/sources${params(payload)}`);
